import React from 'react';

import { ContentDocument } from 'components';
import {
  Grid,
  Checkbox,
  FormControlLabel,
  Typography,
  Drawer,
  Button,
  IconButton
} from '@material-ui/core';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import { textSecondary, white } from 'common/colors';

const AGREE_RIPLAY =
  'Saya telah menyetujui Ringkasan Informasi Produk dan Layanan.';
const AGREE_PROMO =
  'Saya setuju untuk menerima informasi dan promo dari Bank Raya.';

const DrawerRIPLAY = props => {
  const {
    setError,
    docRiplay,
    setCheckRiplay,
    setCheckPromo,
    checkRiplay,
    isCustomerConsent,
    isPersonalConsent,
    isGeneralConsent,
    docType,
    actionButtonLabel,
    setDrawerRiplay,
    drawerRiplay,
    modalHandler,
    checkPromo
  } = props;

  const onCheckBoxRiplay = event => {
    const statusCheck = event.target.checked;
    setCheckRiplay(statusCheck);
    isCustomerConsent !== 'Y' &&
      isPersonalConsent &&
      setCheckPromo(statusCheck);
  };

  const onCheckBoxPromo = event => {
    const statusCheck = event.target.checked;
    setCheckPromo(statusCheck);
  };

  const agreeRiplay = (
    <FormControlLabel
      control={
        <Checkbox
          checked={checkRiplay}
          color="secondary"
          onChange={onCheckBoxRiplay}
          sx={{ padding: 0 }}
        />
      }
      label={
        <div>
          <Typography color="textPrimary" variant="caption">
            {AGREE_RIPLAY}
          </Typography>
        </div>
      }
      style={{ margin: '8px 0 0 0' }}
    />
  );

  const agreePromo = (
    <FormControlLabel
      control={
        <Checkbox
          checked={checkPromo}
          color="secondary"
          onChange={onCheckBoxPromo}
          sx={{ padding: 0 }}
        />
      }
      label={
        <div>
          <Typography color="textPrimary" variant="caption">
            {AGREE_PROMO}
          </Typography>
        </div>
      }
      style={{ margin: '8px 0 0 0' }}
    />
  );

  const contents = docRiplay && (
    <ContentDocument
      content={docRiplay}
      docType={docType}
      setError={setError}
    />
  );

  return (
    <Drawer
      PaperProps={{
        elevation: 0,
        style: {
          borderTopLeftRadius: '16px',
          borderTopRightRadius: '16px',
          margin: '0 auto',
          maxHeight: 'calc(100% - 24px)',
          maxWidth: '500px',
          minHeight: '18%'
        }
      }}
      anchor="bottom"
      onClose={() => setDrawerRiplay(!drawerRiplay)}
      onOpen={() => setDrawerRiplay(!drawerRiplay)}
      open={drawerRiplay}
    >
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        style={{
          borderTopLeftRadius: '16px',
          borderTopRightRadius: '16px',
          backgroundColor: white,
          marginBottom: '8px',
          position: 'fixed',
          zIndex: 1300,
          padding: '16px',
          maxWidth: '500px'
        }}
      >
        <IconButton
          color="textSecondary"
          onClick={() => setDrawerRiplay(!drawerRiplay)}
          style={{
            padding: '4px',
            color: textSecondary
          }}
        >
          <CloseRoundedIcon />
        </IconButton>
      </Grid>

      <Grid container direction="column" style={{ padding: '16px' }}>
        <Typography
          color="textPrimary"
          style={{ margin: '48px 0px 24px 0px' }}
          variant="subtitle1"
        >
          Ringkasan Informasi Produk dan Layanan
        </Typography>
        <Grid container direction="column" item>
          <Grid item>{contents}</Grid>
          <Grid item>
            {isPersonalConsent && agreeRiplay}
            {isCustomerConsent !== 'Y' && isPersonalConsent && agreePromo}
          </Grid>
        </Grid>
        <Grid
          component="footer"
          container
          direction="column"
          item
          style={{ marginTop: '12px' }}
        >
          <Button
            color="secondary"
            disabled={isGeneralConsent || checkRiplay ? false : true}
            fullWidth
            onClick={modalHandler}
            style={{ borderRadius: '8px' }}
            variant="contained"
          >
            {actionButtonLabel}
          </Button>
        </Grid>
      </Grid>
    </Drawer>
  );
};

export default DrawerRIPLAY;
